import type { ProjectMembership } from "@medplum/fhirtypes";

import { createLocalStorageCache } from "@/lib/utils/local-storage-cache";

/**
 * Persists the last active project selection across page refreshes.
 *
 * Always stores a Project.id, for both super admins and regular users.
 */
export const activeProjectCache = createLocalStorageCache<string | null>(
  "medplum-active-project",
  null
);

export const membershipsCache = createLocalStorageCache<ProjectMembership[]>(
  "medplum-auth-memberships",
  []
);
